import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { Checkbox, Col, DatePicker, Form, Radio, Row, Spin, Table } from "antd";
import moment from "moment";

import DashboardApi from "../../../../apis/Dashboard.api";

/**
 * 접근 제한된 브랜드 id 리스트
 * @type {number[]}
 */
const restrainedIdList = [4, 7, 8, 9];

const StatisticsDashboard = () => {
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const [dateType, setDateType] = useState("today");
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    // {label: "6개월", value: "6month"}
  ];
  const [searchOptions, setSearchOptions] = useState({
    // searchType: "payment_created_at",
    // searchStatus: "total",
    startDate: moment().startOf("day"),
    endDate: moment().endOf("day"),
    isCooperate: null,
  });

  const [statistics, setStatisitcs] = useState({
    numbers: 0,
    total_price: 0,
    // profit: 0,
    productList: [],
  });

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  const columns = [
    {
      title: "상품명",
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
      width: "35%",
      align: "center",
    },
    {
      title: "옵션명",
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
      width: "35%",
      align: "center",
    },
    {
      title: "매출금액",
      dataIndex: "price_1",
      key: "price_1",
      ellipsis: true,
      width: "15%",
      align: "center",
      render: (value) => {
        return (
          <span
            style={{
              color: "#117ffa",
              maxWidth: "15%",
              overflow: "hidden",
            }}
          >
            {value?.toLocaleString()}
          </span>
        );
      },
    },
    {
      title: "판매수량",
      dataIndex: "totalCnt",
      key: "totalCnt",
      width: "15%",
      align: "center",
      render: (value) => {
        return (
          <span style={{ color: "#1ca717" }}>{value?.toLocaleString()}</span>
        );
      },
    },
  ];

  useEffect(() => {
    if (searchOptions?.startDate && searchOptions?.endDate) {
      getStatistics();
    }
  }, [searchOptions]);

  const handleCooperateCheck = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setSearchOptions({
        ...searchOptions,
        isCooperate: true,
      });
    } else {
      setSearchOptions({
        ...searchOptions,
        isCooperate: null,
      });
    }
  };

  /**
   * 통계 데이터 가져오기
   * @returns {Promise<void>}
   */
  const getStatistics = async () => {
    let param = {
      startDate: moment(searchOptions.startDate)
        .startOf("day")
        .format("YYYYMMDDHHmm"),
      endDate: moment(searchOptions.endDate)
        .endOf("day")
        .format("YYYYMMDDHHmm"),
      // queryList: "",
      userId: user.id === 724 ? 1 : user.id,
      isCooperate: searchOptions.isCooperate,
    };

    // const res = await DashboardApi.orderStatisticsTogether(param);
    const rsp = await DashboardApi.orderStatistics(param);
    if (rsp.code === 200) {
      setStatisitcs({
        numbers: rsp.result.purchases_num ?? 0,
        // total_price: res.result.combined_amount ?? 0,
        total_price: rsp.result.total_purchase_amount ?? 0,
        // profit: res.result.profit_amount ?? 0,
        productList: rsp.result.productListWithOrder,
      });
    }
  };

  return (
    <Row className="order-component-box main-component-box">
      {isLoading && <Spin />}
      <div className={`order-component-title-div main-component-title-div`}>
        <h2 className="order-component-title">매출/판매 통계</h2>
        {!restrainedIdList.includes(user.id) && (
          <Checkbox onChange={handleCooperateCheck}>공동구매만 보기</Checkbox>
        )}
      </div>
      <div
        className={`order-component-info`}
        style={{
          gap: "1.5rem",
        }}
      >
        <Row
          className={`order-component-each`}
          align={"middle"}
          id={`statistics-date`}
          style={{ gap: "4px" }}
        >
          <Form.Item
            style={{
              margin: 0,
              padding: 0,
            }}
          >
            <Radio.Group
              options={dateTypeItems}
              onChange={handleDateTypeChange}
              value={dateType}
              optionType="button"
              className={`options-list`}
              style={{
                padding: 0,
              }}
            />
            <Row
              align={"middle"}
              style={{
                gap: "3px",
              }}
            >
              <DatePicker
                className="main-statistics-date"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                allowClear={false}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              <span className={`gray-font`}>~</span>
              <DatePicker
                className="main-statistics-date"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                allowClear={false}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
        </Row>
        <Row className={`order-component-each`} align={"middle"}>
          <div className={`order-component-each-detail`}>
            <h4 className={`order-each-detail-title`}>
              {moment(searchOptions.startDate).format("YYYY.MM.DD")} ~{" "}
              {moment(searchOptions.endDate).format("YYYY.MM.DD")}
            </h4>
            <Col className={`main-component-col`}>
              {/* 총 매출액 */}
              <Row
                className="order-component-box main-component-sell"
                style={{
                  gap: "8px",
                  rowGap: "8px",
                  padding: "1.5rem 0",
                  flex: 1,
                }}
              >
                <h4 className={`order-each-detail-title`}>총 매출액</h4>
                <p className={`big-font`} style={{ color: "#117FFA" }}>
                  {statistics.total_price?.toLocaleString()}원
                </p>
              </Row>

              {/* 판매건수 */}
              <Row
                className="order-component-box main-component-sell"
                style={{
                  gap: "8px",
                  rowGap: "8px",
                  padding: "1.5rem 0",
                  flex: 1,
                }}
              >
                <h4 className={`order-each-detail-title`}>판매건수</h4>
                <p className={`big-font`} style={{ color: "#1ca717" }}>
                  {statistics.numbers?.toLocaleString()}건
                </p>
              </Row>

              {/* 객단가 */}
              <Row
                className="order-component-box main-component-sell"
                style={{
                  gap: "8px",
                  rowGap: "8px",
                  padding: "1.5rem 0",
                  flex: 1,
                }}
              >
                <h4 className={`order-each-detail-title`}>객단가</h4>
                <p className={`big-font`} style={{ color: "#bbc71d" }}>
                  {statistics.numbers
                    ? Math.floor(
                        Number(statistics.total_price / statistics.numbers),
                      )?.toLocaleString()
                    : 0}
                  원
                </p>
              </Row>
            </Col>
          </div>
        </Row>
        <Row className={`order-component-each`} align={"middle"}>
          <div className={`order-component-each-detail`}>
            <h4 className={`order-each-detail-title`}>상품별 상세내역</h4>
            <Table
              className="order-create-product-list-table"
              // rowSelection={productRowSelection}
              columns={columns}
              dataSource={statistics.productList}
              loading={isLoading}
              bordered
              size="middle"
              rowKey="id"
              rowClassName="coupon-table-row"
              // scroll={{y: 'calc(191px - 48px)'}}
              // onRow={handleProductRowEvent}
              // onChange={tableOnChange}
              // tableLayout="auto"
              pagination={false}
            />
          </div>
        </Row>
      </div>
    </Row>
  );
};
export default StatisticsDashboard;
